import { NgModule } from '@angular/core';
import { PercentagePipe } from './percentage/percentage.pipe';
import { FormFilterPipe } from './form-filter/form-filter.pipe';
import { DoubleValuePipe } from './double-value/double-value.pipe';
import { SafePipe } from './safe/safe.pipe';
import { SortPipe } from './sort.pipe';
import { TimePipe } from './time/time.pipe';
import { IndexOfPipe } from './indexOf/index-of.pipe';
import { DatediffPipe } from './datediff/datediff.pipe';
import { CalcHoursMinutesPipe } from './calc-hours-minutes/calc-hours-minutes.pipe';


const pipes = [
  PercentagePipe,
  FormFilterPipe,
  DoubleValuePipe,
  SafePipe,
  TimePipe,
  IndexOfPipe,
  SortPipe,
  DatediffPipe,
  CalcHoursMinutesPipe
]
@NgModule({
  declarations: [
    ...pipes,
    CalcHoursMinutesPipe,
  ],
  exports: [
    ...pipes
  ]
})
export class PipesModule { }
